export default __webpack_public_path__ + "9d547c7840b2a38be8bb856fa001dfd0.svg";